<template>
    <div v-html="operator_list">
    </div>
</template>

<script>

export default {
    name: 'operator-list-tab',
    props: {
        geo: {
            type: String,
            required: true,
        },
        region: {
            type: String|Boolean,
            required: false,
        },
        oplistHash: {
            type: String,
            required: true,
        },
        rankId: {
            type: String,
            required: true,
        },
        listId: {
            type: String,
            required: true,
        },
        oplistTab: {
            type: String,
            required: true,
        },
        selectedTab: {
            type: String,
            required: false,
        },
        workerApi: {
            typw: String,
            required: true,
        },
        defaultRegion: {
            type: String,
            default: null,
        },
        overrideRegion: {
            type: String,
            default: null,
        },
        initialItems: {
            type: String|Number,
            required: true,
        },
        itemsPerPage: {
            type: String|Number,
            required: true,
        },
        paginationContainerId: {
            type: String,
            required: true,
        },
        abTestVariant: {
            type: String,
        },
    },
    data: function () {
        return {
            mutableSelectedState: this.selectedState,
            operator_list: null,
            endpoint: this.workerApi + '/operator-list?',
            isLoaded: false,
            oplistTabClass: 'operator-list-tab-'+this.oplistTab,
        }
    },
    methods: {
        getOplist() {
            axios
                .get(this.endpoint, {params: this.axiosParams})
                .then((response) => {
                    if(response.data.success) {
                        this.operator_list = response.data.data.operator_list;
                        setTimeout(() => {
                            // Had to do this because initialising in operator-list/primary.blade.php doesn't work
                            // Maybe there is a better way of doing it??
                            if (document.getElementById(this.paginationContainerId)) {
                                new Vue({
                                    el: '#' + this.paginationContainerId,
                                });
                            }else{
                                console.log('element not found in tabbed oplist ' + this.paginationContainerId);
                            }

                            ktag.reRender(); // track impressions and seenopitems and click event
                        }, 500)
                    } else {
                        console.log(response.data.message);   
                    }     
                })
                .catch((error) => {
                    console.log('--------------- error loading worker API ---------------');
                });
        }
    },
    computed: {
        axiosParams() {
            const params = new URLSearchParams();
            params.append('geo', this.geo);
            if(this.overrideRegion) {
                params.append('region', this.overrideRegion.toLowerCase());
            } else if(this.region) {
                if(this.geo == "CA" && (this.region != "ON" && this.region != "AB")) {
                    this.region = "AB";
                }
                if(this.geo == "CA-FR" && (this.region != "ON" && this.region != "QC")) {
                    this.region = "QC";
                }
                params.append('region', this.region.toLowerCase());
            } else if(!this.region && this.defaultRegion) {
                params.append('region', this.defaultRegion.toLowerCase());
            }
            params.append('rank_id', this.rankId);
            params.append('hash', this.oplistHash);
            params.append('initial_items', this.initialItems);
            params.append('items_per_page', this.itemsPerPage);
            params.append('page', 1);
            return params;
        },
        getOplistWrapContainerID() {
            if(this.abTestVariant) {
                return '#filterable-op-list-' + this.abTestVariant;
            }
            return '#filterable-op-list';
        }
    },
    watch: {
        selectedTab() {
            if(!this.isLoaded && (this.selectedTab == this.oplistTab)) {
                this.getOplist();
                this.isLoaded = true;
            } 
        }
    },
    updated() {
        document.querySelector(this.getOplistWrapContainerID + ' .' + this.oplistTabClass + ' .operator-list').style.display = "block";
        if (typeof more_info_open !== "undefined") { 
            more_info_open(this.listId + '_1');
        }
    }
}
</script>
